// import React, { useCallback, useEffect } from "react";
// import {
//   ReactFlow,
//   MiniMap,
//   Background,
//   useNodesState,
//   useEdgesState,
//   addEdge,
//   // Controls,
// } from "@xyflow/react";

// const proOptions = { hideAttribution: true };

// const VisualRep = ({ questionListData }) => {
//   // console.log("questionListData>>>>", questionListData[0].questions.length);

//   // Initialize nodes with empty data or fallback to an empty array
//   const initialNodes = questionListData
//     ? questionListData.flatMap((sec) =>
//         sec.questions.map((ques, quesIndex) => ({
//           id: `${ques.que_pk_id}`,
//           position: { x: quesIndex * 150, y: quesIndex * 100 },
//           data: { label: ques.que_text },
//         }))
//       )
//     : [];

//   // Initialize edges based on question dependencies or fallback to an empty array
//   const initialEdges = questionListData
//     ? questionListData.flatMap((sec) =>
//         sec.questions
//           .filter((question) => question.que_is_logic && question.que_logic)
//           .flatMap((question) => {
//             const logic = JSON.parse(question.que_logic);
//             return logic.rules.map((rule) => ({
//               id: `e${rule.fieldId}-${question.que_pk_id}`,
//               source: `${rule.fieldId}`,
//               target: `${question.que_pk_id}`,
//               type: "smoothstep",
//             }));
//           })
//       )
//     : [];

//   const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
//   const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);

//   const onConnect = useCallback(
//     (params) => setEdges((eds) => addEdge(params, eds)),
//     [setEdges]
//   );

//   useEffect(() => {
//     if (questionListData) {
//       const updatedNodes = questionListData.flatMap((sec) =>
//         sec.questions.map((ques, quesIndex) => ({
//           id: `${ques.que_pk_id}`,
//           position: { x: quesIndex + 100, y: quesIndex + 150 },
//           data: { label: ques.que_text },
//         }))
//       );

//       const updatedEdges = questionListData.flatMap((sec) =>
//         sec.questions
//           .filter((question) => question.que_is_logic && question.que_logic)
//           .flatMap((question) => {
//             const logic = JSON.parse(question.que_logic);
//             return logic.rules.map((rule) => ({
//               id: `e${rule.fieldId}-${question.que_pk_id}`,
//               source: `${rule.fieldId}`,
//               target: `${question.que_pk_id}`,
//               type: "smoothstep",
//             }));
//           })
//       );

//       setNodes(updatedNodes);
//       setEdges(updatedEdges);
//     }
//   }, [questionListData, setNodes, setEdges]);

//   return (
//     <div style={{ height: "100%", width: "100%" }}>
//       <ReactFlow
//         nodes={nodes}
//         edges={edges}
//         onNodesChange={onNodesChange}
//         onEdgesChange={onEdgesChange}
//         onConnect={onConnect}
//         fitView
//         minZoom={0.2}
//         // attributionPosition="top-right"
//         fitViewOptions={{ padding: 3 }}
//         proOptions={proOptions}
//         style={{ backgroundColor: "#F7F9FB" }}
//       >
//         <MiniMap zoomable pannable />
//         {/* <Controls /> */}
//         <Background />
//       </ReactFlow>
//     </div>
//   );
// };

// export default VisualRep;

// import React, { useCallback, useEffect } from "react";
// import {
//   ReactFlow,
//   MiniMap,
//   Background,
//   useNodesState,
//   useEdgesState,
//   addEdge,
// } from "@xyflow/react";

// const proOptions = { hideAttribution: true };

// const VisualRep = ({ questionListData }) => {
//   console.log("questionListData>>>>>", questionListData[0]?.questions);
//   // Initialize nodes with empty data or fallback to an empty array
//   const initialNodes = questionListData
//     ? questionListData.flatMap((sec) =>
//         sec.questions.map((ques, quesIndex) => ({
//           id: `${ques.que_pk_id}`,
//           position: { x: quesIndex * 150, y: quesIndex * 100 },
//           data: { label: ques.que_text },
//         }))
//       )
//     : [];

//   // Initialize edges based on question dependencies or fallback to an empty array
//   const initialEdges = questionListData
//     ? questionListData.flatMap((sec) =>
//         sec.questions
//           .filter((question) => question.que_is_logic && question.que_logic)
//           .flatMap((question) => {
//             const logic = JSON.parse(question.que_logic);
//             return logic.rules.map((rule) => ({
//               id: `e${rule.fieldId}-${question.que_pk_id}`,
//               source: `${rule.fieldId}`,
//               target: `${question.que_pk_id}`,
//               type: "smoothstep",
//             }));
//           })
//       )
//     : [];

//   const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
//   const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);

//   const onConnect = useCallback(
//     (params) => setEdges((eds) => addEdge(params, eds)),
//     [setEdges]
//   );

//   useEffect(() => {
//     if (questionListData) {
//       const updatedNodes = questionListData.flatMap((sec, secIndex) =>
//         sec.questions.map((ques, quesIndex) => ({
//           id: `${ques.que_pk_id}`,
//           // position: { x: quesIndex * 160 + 150, y: quesIndex * 80 },
//           position: {
//             x: 150 + quesIndex * 150,
//             y: secIndex * 150 + quesIndex * 150,
//           },
//           data: { label: ques.que_text },
//         }))
//       );

//       const updatedEdges = questionListData.flatMap((sec) =>
//         sec.questions
//           .filter((question) => question.que_is_logic && question.que_logic)
//           .flatMap((question) => {
//             const logic = JSON.parse(question.que_logic);
//             return logic.rules.map((rule) => ({
//               id: `e${rule.fieldId}-${question.que_pk_id}`,
//               source: `${rule.fieldId}`,
//               target: `${question.que_pk_id}`,
//               type: "smoothstep",
//             }));
//           })
//       );
//       setNodes(updatedNodes);
//       setEdges(updatedEdges);
//     }
//   }, [questionListData, setNodes, setEdges]);

//   return (
//     <div style={{ height: "100%", width: "100%" }}>
//       <ReactFlow
//         nodes={nodes}
//         edges={edges}
//         onNodesChange={onNodesChange}
//         onEdgesChange={onEdgesChange}
//         onConnect={onConnect}
//         fitView
//         minZoom={0.2}
//         fitViewOptions={{ padding: 3 }}
//         proOptions={proOptions}
//         style={{ backgroundColor: "#F7F9FB" }}
//       >
//         <MiniMap zoomable pannable />
//         <Background />
//       </ReactFlow>
//     </div>
//   );
// };

// export default VisualRep;

import React, { useCallback, useEffect } from "react";
import {
  ReactFlow,
  MiniMap,
  Background,
  useNodesState,
  useEdgesState,
  addEdge,
} from "@xyflow/react";

const proOptions = { hideAttribution: true };

const VisualRep = ({ questionListData }) => {
  // console.log("questionListData>>>>>>>", questionListData[0].questions);

  // Calculate positions and set up nodes and edges
  const initialNodes = questionListData
    ? questionListData.flatMap((sec) =>
        sec.questions.map((ques, index) => ({
          id: `${ques.que_pk_id}`,
          position: { x: index * 250, y: 50 }, // Default linear layout
          data: { label: ques.que_text },
        }))
      )
    : [];

  const initialEdges = questionListData
    ? questionListData.flatMap((sec) =>
        sec.questions
          .filter((question) => question.que_is_logic && question.que_logic)
          .flatMap((question) => {
            const logic = JSON.parse(question.que_logic);
            return logic.rules.map((rule) => ({
              id: `e${rule.fieldId}-${question.que_pk_id}`,
              source: `${rule.fieldId}`,
              target: `${question.que_pk_id}`,
              type: "smoothstep",
            }));
          })
      )
    : [];

  const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);

  const onConnect = useCallback(
    (params) => setEdges((eds) => addEdge(params, eds)),
    [setEdges]
  );

  useEffect(() => {
    if (questionListData) {
      const updatedNodes = [];
      const nodePositions = {};
      let yOffset = 50;

      questionListData[0].questions.forEach((ques, index) => {
        let xPosition = index * 200;
        let yPosition = yOffset;

        if (ques.que_is_logic && ques.que_logic) {
          const logic = JSON.parse(ques.que_logic);
          logic.rules.forEach((rule) => {
            const parentId = rule.fieldId;
            if (nodePositions[parentId]) {
              // Position child nodes below parent
              yPosition = nodePositions[parentId].y + 150;
              nodePositions[parentId].childCount =
                (nodePositions[parentId].childCount || 0) + 1;
              xPosition =
                nodePositions[parentId].x +
                200 * (nodePositions[parentId].childCount - 1)-100;
            }
          });
        }

        nodePositions[ques.que_pk_id] = { x: xPosition, y: yPosition };
        updatedNodes.push({
          id: `${ques.que_pk_id}`,
          position: { x: xPosition, y: yPosition },
          data: { label: ques.que_text },
        });
      });

      const updatedEdges = questionListData.flatMap((sec) =>
        sec.questions
          .filter((question) => question.que_is_logic && question.que_logic)
          .flatMap((question) => {
            const logic = JSON.parse(question.que_logic);
            return logic.rules.map((rule) => ({
              id: `e${rule.fieldId}-${question.que_pk_id}`,
              source: `${rule.fieldId}`,
              target: `${question.que_pk_id}`,
              type: "smoothstep",
            }));
          })
      );

      setNodes(updatedNodes);
      setEdges(updatedEdges);
    }
  }, [questionListData, setNodes, setEdges]);

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <ReactFlow
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={onConnect}
        fitView
        minZoom={0.2}
        fitViewOptions={{ padding: 3 }}
        proOptions={proOptions}
        style={{ backgroundColor: "#F7F9FB" }}
      >
        <MiniMap zoomable pannable />
        <Background />
      </ReactFlow>
    </div>
  );
};

export default VisualRep;
